import styled, { css } from 'styled-components';
import { themeGet, color, getBorderColor } from '@magalu/stereo-ui-styles';
import { typography, position } from 'styled-system';
import { Flex, Box } from '../../atoms';
export const Container = styled(Flex).attrs(props => Object.assign({
  bg: 'background.lighter'
}, props))`
  position: relative;
  border-radius: ${({
  desktopMode
}) => desktopMode ? 2 : 6}px;
  align-items: center;
  flex-direction: column;
  width: 100%;

  ${({
  inputChange
}) => inputChange && css`
      align-items: baseline;
      left: 0;
      z-index: ${themeGet('zIndices.3')};

      ${({
  desktopMode
}) => desktopMode ? css`
              top: 0;
              border: 1px solid ${getBorderColor('whisper')};
            ` : css`
              top: 3px;
              margin-left: -9px;
              width: calc(100% + 18px);
              border-radius: 0;
              padding: ${themeGet('space.1')}px 0;
            `};
    `}

  ${color}
`;
export const SearchOverlay = styled.div.attrs(props => Object.assign({
  bg: 'background.overlay',
  zIndex: 1,
  top: 40,
  left: 0
}, props))`
  position: absolute;
  width: 100%;
  height: 100vh;
  opacity: 'block';
  display: 'block';
  ${color}
  ${position}
`;
export const DesktopPrefix = styled(Box).attrs(props => Object.assign({
  fontSize: 1,
  color: 'text.scratched'
}, props))`
  ${typography}
  ${color}
`;